import * as React from 'react';
import { twMerge } from '@belong/common/twMerge';
import { ImgixClient } from '@belong/common/ImgixClient';
import cssImage from './Image.module.css.js';

function isExternal(to) {
  return to.includes('://');
}
const defaultClient = new ImgixClient({
  domain: 'belonghome.imgix.net'
});
// TODO: handle empty alt with aria values?
const Image = /*#__PURE__*/React.forwardRef(function Image({
  className,
  src,
  width,
  height,
  config,
  sizes,
  client = defaultClient,
  lazy = true,
  preload = false,
  Head,
  ...rest
}, ref) {
  if (isExternal(src)) {
    return /*#__PURE__*/React.createElement("img", {
      src: src,
      className: twMerge('block w-full h-full', cssImage.imageBase, className),
      ...rest,
      ref: ref
    });
  }
  const _src = client.buildURL(src, {
    auto: 'format',
    ...config
  });
  const srcSet = client.buildSrcSet(src, {
    auto: 'format',
    ...config
  }, {
    widthTolerance: 0.2
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, preload && Head && /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    as: "image",
    href: _src,
    imageSrcSet: srcSet,
    imagesizes: sizes
  })), /*#__PURE__*/React.createElement("img", {
    src: _src,
    // Approach taken from here: https://ivopetkov.com/b/lazy-load-responsive-images/
    srcSet: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    "data-srcset": srcSet,
    className: twMerge('block w-full h-full', lazy && 'lazyload', cssImage.imageBase, className),
    "data-sizes": sizes ?? 'auto',
    ...rest,
    ref: ref
  }));
});

export { Image };
